import { render, staticRenderFns } from "./masking.vue?vue&type=template&id=48d8085a&scoped=true&"
import script from "./masking.vue?vue&type=script&lang=js&"
export * from "./masking.vue?vue&type=script&lang=js&"
import style0 from "./masking.vue?vue&type=style&index=0&id=48d8085a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8085a",
  null
  
)

component.options.__file = "masking.vue"
export default component.exports